import { render, staticRenderFns } from "./RequestPasswordReset.vue?vue&type=template&id=1dba5d1e&scoped=true"
import script from "./RequestPasswordReset.vue?vue&type=script&lang=ts"
export * from "./RequestPasswordReset.vue?vue&type=script&lang=ts"
import style0 from "./RequestPasswordReset.vue?vue&type=style&index=0&id=1dba5d1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dba5d1e",
  null
  
)

/* custom blocks */
import block0 from "./password.fr.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fcodebuild%2Foutput%2Fsrc2173210599%2Fsrc%2Fgit-codecommit.eu-west-3.amazonaws.com%2Fv1%2Frepos%2Farqana-front-myarqana%2Fsrc%2Fviews%2Fpassword-reset%2FRequestPasswordReset.vue&external"
if (typeof block0 === 'function') block0(component)
import block1 from "./password.en.json?vue&type=custom&index=1&blockType=i18n&issuerPath=%2Fcodebuild%2Foutput%2Fsrc2173210599%2Fsrc%2Fgit-codecommit.eu-west-3.amazonaws.com%2Fv1%2Frepos%2Farqana-front-myarqana%2Fsrc%2Fviews%2Fpassword-reset%2FRequestPasswordReset.vue&external"
if (typeof block1 === 'function') block1(component)

export default component.exports